// extracted by mini-css-extract-plugin
export var dividerLine = "_4o-0";
export var errorBackground = "_4o-1";